var _classCallCheck = require("/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _inherits = require("/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _createSuper = require("/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");
var Base = require('./base');
var JQueryService = /*#__PURE__*/function (_Base) {
  "use strict";

  _inherits(JQueryService, _Base);
  var _super = _createSuper(JQueryService);
  function JQueryService() {
    _classCallCheck(this, JQueryService);
    return _super.apply(this, arguments);
  }
  _createClass(JQueryService, [{
    key: "request",
    value: function request(options, params) {
      var _this = this;
      var _params$connection = params.connection,
        connection = _params$connection === void 0 ? {} : _params$connection;
      var headers = Object.assign({}, options.headers, this.options.headers, connection.headers);
      var opts = Object.assign({
        dataType: options.type || 'json'
      }, connection, options, {
        headers: headers
      });
      if (options.body) {
        opts.data = JSON.stringify(options.body);
        opts.contentType = 'application/json';
      }
      delete opts.type;
      delete opts.body;
      return new Promise(function (resolve, reject) {
        _this.connection.ajax(opts).then(resolve, function (xhr) {
          var error = xhr.responseText;
          try {
            error = JSON.parse(error);
          } catch (e) {
            error = new Error(xhr.responseText);
          }
          error.xhr = error.response = xhr;
          reject(error);
        });
      });
    }
  }]);
  return JQueryService;
}(Base);
module.exports = JQueryService;